import { createScale } from '../internal';
export const temperatureBounds = [{
  lower: -Infinity,
  upper: 35.0,
  score: {
    type: 'low',
    value: 3
  }
}, {
  lower: 35.1,
  upper: 36.0,
  score: {
    type: 'low',
    value: 1
  }
}, {
  lower: 36.1,
  upper: 38.0,
  score: {
    type: 'normal',
    value: 0
  }
}, {
  lower: 38.1,
  upper: 39.0,
  score: {
    type: 'high',
    value: 1
  }
}, {
  lower: 39.1,
  upper: Infinity,
  score: {
    type: 'high',
    value: 2
  }
}];
/**
 * Temperature (°C) `float` (float value can have at most one decimal)
 */

export const temperature = createScale(temperatureBounds, 1);
//# sourceMappingURL=temperature.js.map